export var createLabelsApi = function (baseUrl, http) {
    var base = baseUrl + "/labels";
    var api = {
        getLabels: function () {
            return http.get(base);
        },
        addLabel: function (addLabelDto) {
            return http.post(base, addLabelDto);
        },
        renameLabel: function (renameLabelDto) {
            return http.put(base + "/" + renameLabelDto.id, renameLabelDto);
        },
        deleteLabel: function (deleteLabelDto) {
            return http.delete(base + "/" + deleteLabelDto.id + "?permanentDelete=true");
        }
    };
    return api;
};
//# sourceMappingURL=index.js.map